import React from 'react'
import { useTranslation } from 'react-i18next'

import ToggleField from '../../../../../../../components/Form/ToggleField'
import AppListField from '../../../reusableFields/AppListField'

import { OBJECTIVE } from '../../../../../../Multiplatform/CampaignForms/fields'
import { IOS_14_CAMPAIGN } from '../../../../../../Multiplatform/CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/fields'
import { OUTCOME_APP_PROMOTION } from '../../../../../../../constants/campaigns'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'
import { fontWeightBold } from '../../../../../../../styles/typography'

const AppPromotionIos14Fields = ({ formik }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  if (values[OBJECTIVE] === OUTCOME_APP_PROMOTION) {
    return (
      <div className={drawerFormClasses.subSection}>
        <ToggleField
          name={IOS_14_CAMPAIGN}
          isEnabled={values[IOS_14_CAMPAIGN]}
          setFieldValue={setFieldValue}
          label={'iOS 14+ campaign'}
          fontWeight={fontWeightBold}
          isSolid={false}
        />
        <p>
          {t(
            'Create a campaign to help you reach people using iOS 14.5 and later devices. An iOS 14+ campaign will not deliver to devices using iOS 13.7 or earlier.'
          )}
        </p>
        {values[IOS_14_CAMPAIGN] && <AppListField formik={formik} />}
      </div>
    )
  } else {
    return null
  }
}

export default AppPromotionIos14Fields
